import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';

import { KYMW1308Component } from './kymw1308.component';
import { KYMW1309Module } from '../kymw1309/kymw1309.module';
import { CalcApprovedPriceService } from './api-service/calc-approved-price.service';
import { GetPlanGoodsInfoService } from './api-service/get-plan-goods-info.service';
import { GetPromotionGoodsInfoService } from './api-service/get-promotion-goods-info.service';
import { GetPromotionNoService } from './api-service/get-promotion-no.service';
import { RegistPromotionGoodsService } from './api-service/regist-promotion-goods.service';
import { PlanGoodsLockService } from '../../../../../src/app/commons/kymw00/api-services/plan-goods-lock.service';

/**
 * バンドルミックスマッチ画面 モジュール設定クラス
 *
 * @export KYMW1308Module
 * @class KYMW1308Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
    KYMW1309Module,
  ],
  declarations: [
    KYMW1308Component,
  ],
  providers: [
    CalcApprovedPriceService,
    GetPlanGoodsInfoService,
    GetPromotionGoodsInfoService,
    GetPromotionNoService,
    RegistPromotionGoodsService,
    PlanGoodsLockService,
  ],
})
export class KYMW1308Module {

}
